// To be embedded in app

import HighstreetAppMetaUrl from 'components/highstreet-app-meta-url';
import { SizeGuide } from 'components/shared';
import { fetchContentPayload } from 'lib/contentful/api';
import getSizeGuide from 'lib/contentful/getSizeGuide';
import { getResourceText } from 'lib/resources';
import withStoreLocales from 'lib/storeLocales/staticPaths/withStoreLocales';
import withStoreLocale from 'lib/storeLocales/staticProps/withStoreLocale';
import Head from 'next/head';

const capitalizeFirstLetters = str => {
  return str
    .split(/\b/)
    .map(word => word.charAt(0).toUpperCase() + word.substring(1))
    .join('');
};

export default ({ sizeGuide, slug }) => {
  const t = getResourceText(sizeGuide.resourcesCollection.items);

  return (
    <>
      <Head>
        <title>{t('Title')}</title>
        <HighstreetAppMetaUrl url={`size-guide/${slug}`} />
      </Head>
      <SizeGuide sizeGuide={sizeGuide} show />
    </>
  );
};

export const getStaticProps = withStoreLocale(
  async ({ params: { slug }, preview = false, locale }) => {
    const sizeGuideName = `Size-Guide-${capitalizeFirstLetters(slug)}`;
    const sizeGuide = await getSizeGuide(sizeGuideName, locale, preview);

    if (!sizeGuide)
      return {
        notFound: true,
      };

    return {
      props: { sizeGuide, slug, isApp: true },
    };
  }
);

export const getStaticPaths = withStoreLocales(async ({ storeLocales }) => {
  const slugs = await fetchContentPayload({
    query: `
  query sizeGuidePaths($locale: String, $prefix: String) {
    globalModuleCollection(
      locale: $locale
      limit: 20
      where: { name_contains: $prefix }
    ) {
      items {
        name
      }
    }
  }
`,
    variables: {
      prefix: 'Size-Guide-',
      locale: 'en',
    },
  }).then(r =>
    r.globalModuleCollection.items
      .map(({ name }) => name)
      .filter(Boolean)
      .filter(n => n.startsWith('Size-Guide-'))
      .map(n => n.replace('Size-Guide-', '').toLowerCase())
  );

  const paths = storeLocales.reduce(
    (storeLocalePaths, locale) => [
      ...storeLocalePaths,
      ...slugs.map(slug => ({ locale, params: { slug } })),
    ],
    []
  );

  return {
    paths,
    fallback: 'blocking',
  };
});
